"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudConfigSchema = void 0;
const zod_1 = require("zod");
const rate_limits_1 = require("./rate-limits");
const plans_1 = require("../features/entitlements/plans");
exports.CloudConfigSchema = zod_1.z.object({
    plan: zod_1.z.enum(plans_1.cloudConfigPlans).optional(),
    monthlyObservationLimit: zod_1.z.number().int().positive().optional(),
    // used for table and dashboard queries
    defaultLookBackDays: zod_1.z.number().int().positive().optional(),
    // need to update stripe webhook if you change this, it fetches from db via these fields
    stripe: zod_1.z
        .object({
        customerId: zod_1.z.string().nullish(),
        activeSubscriptionId: zod_1.z.string().nullish(),
        activeProductId: zod_1.z.string().nullish(),
        activeUsageProductId: zod_1.z.string().nullish(),
        subscriptionStatus: zod_1.z.string().nullish(), // should be one of ["active","past_due", "unpaid", "canceled", "incomplete", "incomplete_expired", "paused"]; we don't enforce to have a backwards compatibility for this field
    })
        .transform((data) => ({
        ...data,
        isLegacySubscription: data?.activeProductId != null && data?.activeUsageProductId == null,
    }))
        .nullish(),
    // custom rate limits for an organization
    rateLimitOverrides: rate_limits_1.CloudConfigRateLimit.optional(),
});
